import { DeleteArcgisCivil3dAlignmentSettingsApiRequest } from 'types/requests/arcgis-civil3d-settings/alignments/delete-arcgis-civil3d-alignment-settings.request';
import { ArcgisCivil3dAlignmentSettingApiModel } from '../../../types/models/arcgis-civil3d-alignment-setting.model';
import { CreateArcgisCivil3dAlignmentSettingApiRequest } from '../../../types/requests/arcgis-civil3d-settings/alignments/create-arcgis-civil3d-alignment-setting.request';
import { GetArcgisCivil3dAlignmentSettingApiRequest } from '../../../types/requests/arcgis-civil3d-settings/alignments/get-arcgis-civil3d-alignment-setting.request';
import { SearchArcgisCivil3dAlignmentSettingsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/alignments/search-arcgis-civil3d-alignment-settings.request';
import { UpdateArcgisCivil3dAlignmentSettingApiRequest } from '../../../types/requests/arcgis-civil3d-settings/alignments/update-arcgis-civil3d-alignment-setting.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { ArcgisCivil3dPropertyMappingApiModel } from '../../../types/models/arcgis-civil3d-property-mapping.model';
import { CreatePropertyMappingForAlignmentApiRequest } from '../../../types/requests/arcgis-civil3d-settings/alignments/create-property-mapping-for-alignment.request';
import { DeletePropertyMappingForAlignmentApiRequest } from '../../../types/requests/arcgis-civil3d-settings/alignments/delete-property-mapping-for-alignment.request';
import { GetAllPropertyMappingsForAlignmentApiRequest } from '../../../types/requests/arcgis-civil3d-settings/alignments/get-all-property-mappings-for-alignment.request';
import { UpdatePropertyMappingsForAlignmentApiRequest } from '../../../types/requests/arcgis-civil3d-settings/alignments/update-property-mappings-for-alignment.request';
import { DuplicateArcgisCivil3dAlignmentsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/alignments/duplicate-arcgis-civil3d-alignment-settings.request';
import { CreatePropertyMappingsForAlignmentsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/alignments/create-property-mappings-for-alignments.request';
import { SearchPropertyMappingsForAlignmentsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/alignments/search-property-mappings-for-alignments.request';

export const createAlignmentSetting = (params: CreateArcgisCivil3dAlignmentSettingApiRequest) =>
  client.post<ArcgisCivil3dAlignmentSettingApiModel>('/arcgis-civil3d-settings/alignments', params);

export const updateAlignmentSetting = ({ alignmentId, ...params }: UpdateArcgisCivil3dAlignmentSettingApiRequest) =>
  client.patch<ArcgisCivil3dAlignmentSettingApiModel>(`/arcgis-civil3d-settings/alignments/${alignmentId}`, params);

export const deleteAlignmentSettings = ({ alignmentIds, ...params }: DeleteArcgisCivil3dAlignmentSettingsApiRequest) =>
  client.delete<ArcgisCivil3dAlignmentSettingApiModel>(`/arcgis-civil3d-settings/alignments`, {
    data: { alignmentIds },
    ...params,
  });

export const duplicateAlignmentSettings = (params: DuplicateArcgisCivil3dAlignmentsApiRequest) =>
  client.post<ArcgisCivil3dAlignmentSettingApiModel[]>(`/arcgis-civil3d-settings/alignments/duplicate`, params);

export const getAlignmentSetting = <T extends ArcgisCivil3dAlignmentSettingApiModel>({
  alignmentId,
  ...params
}: GetArcgisCivil3dAlignmentSettingApiRequest) =>
  client.get<T>(`/arcgis-civil3d-settings/alignments/${alignmentId}`, { params });

export const searchAlignmentSettings = <T extends ArcgisCivil3dAlignmentSettingApiModel>(
  params: SearchArcgisCivil3dAlignmentSettingsApiRequest,
) => client.get<CursorPaginatedApiResponse<T>>(`/arcgis-civil3d-settings/alignments`, { params });

export const createPropertyMappingForAlignment = ({
  alignmentId,
  ...params
}: CreatePropertyMappingForAlignmentApiRequest) =>
  client.post<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/alignments/${alignmentId}/property-mappings`,
    { params },
  );

export const searchPropertyMappingsForAlignments = <T extends ArcgisCivil3dPropertyMappingApiModel>(
  params: SearchPropertyMappingsForAlignmentsApiRequest,
) => client.get<CursorPaginatedApiResponse<T>>(`/arcgis-civil3d-settings/alignments/property-mappings`, { params });

export const createPropertyMappingsForAlignments = (params: CreatePropertyMappingsForAlignmentsApiRequest) =>
  client.post<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/alignments/property-mappings`,
    params,
  );

export const updatePropertyMappingsForAlignment = ({
  alignmentId,
  ...params
}: UpdatePropertyMappingsForAlignmentApiRequest) =>
  client.patch<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/alignments/${alignmentId}/property-mappings`,
    params,
  );

export const getAllPropertyMappingsForAlignment = ({ alignmentId }: GetAllPropertyMappingsForAlignmentApiRequest) =>
  client.get<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/alignments/${alignmentId}/property-mappings`,
  );

export const deletePropertyMappingFromAlignment = ({
  alignmentId,
  civil3dPropertyId,
}: DeletePropertyMappingForAlignmentApiRequest) =>
  client.delete<void>(`/arcgis-civil3d-settings/alignments/${alignmentId}/property-mappings/${civil3dPropertyId}`);
